// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  text-align: center;
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.blocks-wrapper {
  margin: auto;
  width: 90%;
  max-width: 630px;
}
.blocks-wrapper div {
  width: 100%;
  height: 87px;
  padding: 0 10px;
  cursor: pointer;
  display: flex;
  border: 1px solid var(--accent-color);
  border-radius: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.blocks-wrapper div img {
  width: auto;
  height: 100%;
}
.blocks-wrapper div p {
  text-align: start;
  padding: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.blocks-wrapper div .img-wrapper {
  width: 61px;
  height: 61px;
  padding: 15px;
  overflow: hidden;
  background: rgba(146, 92, 73, 0.2);
  border-radius: 50%;
  border: none;
  margin-right: 30px;
}
.blocks-wrapper .active {
  background: var(--accent-color);
}
.blocks-wrapper .active .img-wrapper {
  background: #FAF1E3;
}

ion-button {
  width: 90%;
  margin: 0 auto 15px;
}

.back-icon-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
@media (min-width: 991px) {
  .back-icon-left {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-type-selection/order-type-selection.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;EACA,UAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EAuBA,mBAAA;AAvBJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAEI;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAAN;AAEI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAAN;AAKE;EACE,+BAAA;AAHJ;AAII;EACE,mBAAA;AAFN;;AAOA;EACE,UAAA;EACA,mBAAA;AAJF;;AAOA;EACC,kBAAA;EACC,SAAA;EACA,UAAA;AAJF;AC9DE;ED+DF;IAKI,aAAA;EAFF;AACF","sourcesContent":["@import '../../../theme/mixins';\n\nh2 {\n  text-align: center;\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.blocks-wrapper{\n  margin: auto;\n  width: 90%;\n  max-width: 630px;\n\n  div {\n    width: 100%;\n    height: 87px;\n    padding: 0 10px;\n    cursor: pointer;\n    display: flex;\n    border: 1px solid var(--accent-color);\n    border-radius: 8px;\n    align-items: center;\n\n    img {\n      width: auto;\n      height: 100%;\n    }\n    p {\n      text-align: start;\n      padding: 10px 0;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n    }\n    .img-wrapper{\n      width: 61px;\n      height: 61px;\n      padding: 15px;\n      overflow: hidden;\n      background: #925C4933;\n      border-radius: 50%;\n      border: none;\n      margin-right: 30px;\n    }\n    margin-bottom: 10px;\n  }\n\n  .active {\n    background: var(--accent-color);\n    .img-wrapper {\n      background: #FAF1E3;\n    }\n  }\n}\n\nion-button {\n  width: 90%;\n  margin: 0 auto 15px;\n}\n\n.back-icon-left {\n position: absolute;\n  top: 15px;\n  left: 15px;\n  @include desktop {\n    display: none;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
